<template>
	<div class="migration-log-wrapper">
		<div class="migration-log-table" :class="`mig-${migrationLog.length}`">
			<table id="datatable" class="table table-striped table-bordered" cellspacing="0" width="100%">
				<thead>
				<tr>
					<th>Domain Name</th>
					<th>Plan Name</th>
					<th>Current Status</th>
					<th>Submitted At</th>
					<th>Modified At</th>
					<th>FEE</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(acc, index) in migrationLog" :key="index">
					<td>{{ acc.siteDetails.domainName }}</td>
					<td>{{ acc.selectedPlan.planName }}</td>
					<td class="text-center">
						<span class="badge" :class="{'badge-warning' : acc.status === 'pending' || acc.status === 'review' || acc.status === 'abandoned', 'badge-success' : acc.status === 'finished'}">
							{{ (acc.status === 'finished') ? acc.status : 'pending' }}
						</span>
					</td>
					<td class="text-center">
						<span class="badge badge-info">{{ acc.created | formatDate }}</span>
					</td>
					<td class="text-center">
						<span class="badge badge-info">{{ acc.modified | formatDate }}</span>
					</td>
					<td>{{ acc.isMigrationChargeable ? "$25 USD" : "Free" }}</td>
				</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
    import {db} from "@/firebase/init"

    export default {
        name: "MigrationLogComponent",
        data() {
            return {
                currTicketID: null,
                currStatus: null,
				migrationLog: []
            }
        },
        computed: {
            hostingAccounts() {
                return this.$store.getters["hosting/accounts"]
            },
			userUID() {
				return this.$store.getters.getUID
			}
        },
        created() {
            if (this.hostingAccounts.length === 0) {
                this.$store.dispatch("hosting/fetchAccounts")
            }
        },
        async mounted() {
			const submittedMigrationsRef = await db.collection('savedMigrations').where('uid', '==', this.userUID).get();
			submittedMigrationsRef.forEach(doc => {
				console.log(doc.id);
				this.migrationLog.push(doc.data());
			});
            /* eslint-disable */
            $(document).ready(function () {
                $("#datatable").DataTable({
                    pagingType: "simple_numbers",
                    lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
                    responsive: true,
                    retrieve: true,
                    order: [[3, "desc"]],
                    language: {
                        search: "_INPUT_",
                        searchPlaceholder: "Search records",
						emptyTable: "No Pending Migration Currently"
                    }
                });
            });
            /* eslint-enable */
        }
    }
</script>
